/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Notes_FailedInputs */

const en_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to save notes`)
};

const de_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen konnten nicht gespeichert werden`)
};

const fr_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de sauvegarder les notes`)
};

const es_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron guardar las notas`)
};

const it_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvataggio note non riuscito`)
};

const nl_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notities opslaan mislukt`)
};

const pl_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisanie notatek nie powiodło się`)
};

const fi_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muistiinpanojen tallentaminen epäonnistui`)
};

const da_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke gemme noter`)
};

const sv_applications_notes_failed = /** @type {(inputs: Applications_Notes_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte spara anteckningar`)
};

/**
* | output |
* | --- |
* | "Failed to save notes" |
*
* @param {Applications_Notes_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_notes_failed = /** @type {((inputs?: Applications_Notes_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Notes_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_notes_failed(inputs)
	if (locale === "fr") return fr_applications_notes_failed(inputs)
	if (locale === "es") return es_applications_notes_failed(inputs)
	if (locale === "it") return it_applications_notes_failed(inputs)
	if (locale === "nl") return nl_applications_notes_failed(inputs)
	if (locale === "pl") return pl_applications_notes_failed(inputs)
	if (locale === "fi") return fi_applications_notes_failed(inputs)
	if (locale === "da") return da_applications_notes_failed(inputs)
	if (locale === "sv") return sv_applications_notes_failed(inputs)
	return en_applications_notes_failed(inputs)
});